/**
 * This file is part of vue-boilerplate.
 * @link     : https://zhaiyiming.com/
 * @author   : Emil Zhai (root@derzh.com)
 * @modifier : Emil Zhai (root@derzh.com)
 * @copyright: Copyright (c) 2018 TINYMINS.
 */
import { RouteConfig } from 'vue-router';
import { AUTH_STATE } from '@/config';
import { isInMobileDevice } from '@/utils/environment';

export default [
  {
    name: 'index',
    path: '/',
    meta: { tabbar: 'secret/user', parent: 'index', nav: 'index' },
    components: {
      static: () => import('@/views/common/static'),
      header: () => import('@/views/common/header'),
      main: () => import('@/views/common/main'),
      footer: () => import('@/views/common/footer'),
    },
    redirect: { name: 'secret_list' },
    children: [
      {
        name: 'join',
        path: 'join',
        meta: { title: '请先关注公众号【海鳗】' },
        component: () => import('@/views/join.vue'),
      },
      {
        name: 'app',
        path: 'app',
        meta: { title: '客户端下载' },
        component: () => (isInMobileDevice()
          ? import('@/views/app-m.vue')
          : import('@/views/app-pc.vue')),
      },
    ],
  },
  {
    name: 'redirect',
    path: '/redirect',
    meta: { tabbar: 'secret/user', title: '跳转中...' },
    components: {
      static: () => import('@/views/common/static'),
      header: () => import('@/views/common/header'),
      main: () => import('@/views/redirect'),
      footer: () => import('@/views/common/footer'),
    },
  },
  {
    name: 'exception',
    path: '/exception',
    meta: { auth: AUTH_STATE.LOGGED_IN, tabbar: 'secret/user', title: '异常捕获' },
    components: {
      static: () => import('@/views/common/static'),
      header: () => import('@/views/common/header'),
      main: () => import('@/views/exception'),
      footer: () => import('@/views/common/footer'),
    },
  },
  {
    name: '403',
    path: '/403',
    meta: { tabbar: 'secret/user', title: '403：无权限' },
    components: {
      static: () => import('@/views/common/static'),
      header: () => import('@/views/common/header'),
      main: () => import('@/views/403'),
      footer: () => import('@/views/common/footer'),
    },
  },
  {
    name: '404',
    path: '*',
    meta: { tabbar: 'secret/user', title: '404错误：页面不存在' },
    components: {
      static: () => import('@/views/common/static'),
      header: () => import('@/views/common/header'),
      main: () => import('@/views/404'),
      footer: () => import('@/views/common/footer'),
    },
  },
] as RouteConfig[];
